module.exports = __webpack_public_path__ + "static/media/marker_bold_icon.fa241d7d.svg";